import React, { Component } from 'react';

import './CardSlider.scss';

class CardSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: 'blue',
      maxSlides: 0,
      cActive: 0,
      tempoSlider: 3000,
      loaderIndex: 0,
      slides: [],
    };

    this.loop = null;
  }

  componentWillMount = () => {
    const { items, color } = this.props;
    if (items) {
      this.setState({
        maxSlides: items.length - 1,
        slides: items,
        color: color,
      });
    }
  };

  componentDidMount = () => {
    const { autoInit } = this.props;
    if (autoInit) {
      this.initLoader();
    }
  };

  componentWillUnmount = () => {};

  initLoader = () => {
    var percent = this.state.tempoSlider;
    this.loop = setInterval(() => {
      let index = this.state[`loaderBarIndex`];
      index++;
      if (index <= 100) {
        const newState = Object.assign({}, this.state);
        newState[`loaderBarIndex`] = index;
        this.setState(newState);
      } else {
        this.changeTemasNext(this.state[`cActive`] + 1);
      }
    }, percent);
  };

  changeTemasPrev = num => {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive`] = newIndex[`cActive`] - 1 < 0 ? newIndex[`maxSlides`] : num;
    this.setState(newIndex);
    this.reloadTimer();
  };

  changeTemasNext = num => {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive`] = newIndex[`cActive`] + 1 > newIndex[`maxSlides`] ? 0 : num;
    this.setState(newIndex);
    this.reloadTimer();
  };

  reloadTimer = () => {
    const { autoInit } = this.props;
    clearInterval(this.loop);
    this.setState({ loaderIndex: 0 });
    if (autoInit) {
      this.initLoader();
    }
  };

  render = () => {
    const { slides, cActive, maxSlides, color } = this.state;
    const sliderClasses = color ? ['cardslider', `cardslider--${color}`] : ['cardslider'];
    return (
      <div className={sliderClasses.join(' ')}>
        {slides.length > 0 && (
          <div className="cardslider__content">
            <div className="cardslider__content__slides">
              {slides.map((item, index) => {
                let zIndex = (cActive > index) ? (cActive == index) ? 100 : 20 + index : (cActive == index) ? 100 : 20 - index;
                return (
                  <div
                    key={index}
                    className={cActive == index ? ['cardslider__slide active'] : ['cardslider__slide']}
                    style={{zIndex: zIndex}}
                    // onClick={() => this.changeTemasButton(index, '')}
                  >
                    <p>{item.text}</p>
                  </div>
                )
              })}
            </div>
          </div>
        )}

        {slides.length > 0 && (
          <div className="cardslider__nav">
            <div
              className="c__nav__button c__nav__button--prev"
              onClick={() => this.changeTemasPrev(cActive - 1)}
            ></div>
            <div className="c__nav__status">
              <b>{cActive + 1}</b>/{maxSlides + 1}
            </div>
            <div
              className="c__nav__button c__nav__button--next"
              onClick={() => this.changeTemasNext(cActive + 1)}
            ></div>
          </div>
        )}
      </div>
    );
  };
}

export { CardSlider };
